import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@/theme/ThemeProvider';
import { A11yPreferencesProvider } from '@/a11y/A11yPreferencesProvider';
import { routes } from '@/routes/routes';

/**
 * Composizione dei provider.
 *
 * Ordine dichiarato:
 *   ThemeProvider            non dipende dal router
 *   A11yPreferencesProvider  non dipende dal router
 *   RouterProvider
 *     └─ AppLayout monta KioskProvider (che usa useLocation/useNavigate e
 *        quindi DEVE stare dentro il router)
 */
const router = createBrowserRouter(routes);

export function App() {
  return (
    <ThemeProvider>
      <A11yPreferencesProvider>
        <RouterProvider router={router} />
      </A11yPreferencesProvider>
    </ThemeProvider>
  );
}
